module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2a"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _c('span', {
    staticClass: "underline"
  }, [_vm._v("Color, Contrast, and Value")])]), _vm._v(" "), _c('div', {
    staticClass: "keep"
  }, [_c('h3', {
    staticClass: "h3a"
  }, [_vm._v("The Importance of Color")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("It’s easy to see why so many quilters think that color is "), _c('em', [_vm._v("the")]), _vm._v(" most important part of a quilt. Color makes you look. It can evoke emotions. However, color by itself is not the most important part of your quilt.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Every color has a "), _c('em', [_vm._v("value")]), _vm._v(". It will be light, medium, dark, or somewhere in between. "), _c('em', [_vm._v("Contrast")]), _vm._v(" is the difference between two or more values. "), _c('em', [_vm._v("The contrast between different values makes a design visible")]), _vm._v(". Where fabrics high in contrast meet, they are very visible. Fabrics low in contrast placed next to each other blend together.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Look at the fabrics below. Yes, they are different shades of blue, and yes, they are different prints—but they are all medium value.")]), _vm._v(" "), _c('div', {
    staticClass: "keep"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f0010-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Even though fabrics are different, the similarity in color and value makes it hard to see differences between them.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Because these fabrics are so similar in both color and value, it is difficult to tell them apart from a distance. Using only these fabrics in a quilt is a waste of your time if you want people to actually see the pattern.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Adding more values to the original stack of fabric gives you a variety of lights, mediums, and darks with which to work. Using a range of values will help you to see the differences between fabrics.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f0010-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Adding more values provides more contrast.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _vm._v("Placing fabrics high in contrast next to each other in your quilt is one sure way of making that part of the design stand out. If you want to subdue an area, use fabrics that are lower in contrast. Many quilts have areas of both high and low contrast.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("Be aware that just because two fabrics are different")]), _vm._v(" "), _c('strong', [_c('em', [_vm._v("colors")])]), _vm._v(" "), _c('em', [_vm._v("does not mean that the fabrics are different")]), _vm._v(" "), _c('strong', [_c('em', [_vm._v("values")])]), _vm._v(". The blue and green to the right are different colors, but they look nearly the same. If you use them next to each other in a quilt, you may not be able to distinguish blue pieces from green pieces. That can ruin a design.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f0011-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Fabrics that are different colors but similar values blend together and make a design less visible.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Remember also that value is relative. A light yellow may be visible against a dark yellow, but the darkest yellow will still look very light against black.")]), _vm._v(" "), _c('div', {
    staticClass: "keep"
  }, [_c('h3', {
    staticClass: "h3"
  }, [_vm._v("Designs on Fabric")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Fabric comes in solid colors—and everything else.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Solid colors are just that, solid color. It’s easy to think of solids as boring, but that’s not true. Quilts from Amish to modern that are made with only solid fabrics are wonderfully graphic. Many of today’s art quilters use solids much as they would use paint to create amazing quilts.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The “everything else” category of fabric is pretty crowded. Solids, tone-on-tones, and low-contrast prints tend to be quiet. Other fabrics are loud and busy. Busy fabrics tend to be prints that are composed of high-contrast colors or values. Big, busy prints are fun and exciting.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Both quiet and loud fabrics can have a place in appliqué. That said, remember that your appliqué will be easier to see on a quieter background. Small appliqué pieces can get lost on a busy background.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("Scale")]), _vm._v(" refers to the size of the design on the fabric. Large-scale designs look different from small-scale designs. A printed fabric can have any design imaginable on it: tiny little dots, huge flowers, stripes. The list is endless!")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f0011-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Quiet versus loud")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f0011-03.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Small-, medium-, and large-scale prints")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f0012-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Fabric stacks from "), _c('em', [_vm._v("Fanciful Flowers")]), _vm._v(" ("), _c('span', {
    attrs: {
      "href": "#/html/9781607054726_17_pro#page_90",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 90")]), _vm._v(")")]), _vm._v(" "), _c('div', {
    staticClass: "keep"
  }, [_c('h3', {
    staticClass: "h3"
  }, [_vm._v("Choosing Fabric for a Quilt")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Before we begin a quilt, the first thing we decide is what colors we want to work with—what is making us happy right then. We make a stack of fabrics for each new quilt. In that stack are fabric choices for the backgrounds and for the appliqué. We don’t worry about where we will use each fabric; that comes later. For now we focus on fabric that we think might belong in the quilt we are about to make. We begin the stack with fabric from our stashes, adding new fabric from the quilt store as necessary.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("When starting your quilt, "), _c('em', [_vm._v("you have to decide")]), _vm._v(" what "), _c('em', [_vm._v("you")]), _vm._v(" want to use. If you tend to struggle with your color choices, you may be overthinking it. In some ways this is like deciding what clothes you want to put on in the morning. See, you already have practice making color choices!")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("You can begin by choosing at least one color that you really want to work with and then adding to it. We tend to choose the background color first. Monochromatic (one-color) color schemes are simpler to work with than very colorful, scrappy color schemes. Quilts made from two values (light and dark) are simpler than more complex mixes of values. You can look at the quilts in this book or in other books for inspiration. In fact, if you keep your eyes open, you will find inspiration all around you.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("After you have decided on colors and selected fabric, separate the background fabric from the appliqué fabric. If you have several background fabrics, stack them from darkest to lightest. This is not as hard as it sounds. Look at the background fabric in front of you and choose the darkest piece. Start the stack with this piece. Continue choosing the darkest fabric and placing it on the stack. You may or may not be able to use all of these fabrics.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Next, sort the appliqué fabrics by color. You might have a green stack, a red stack, a blue stack, and so on. Sort each color from dark to light as described above. Some fabrics could go in more than one stack: Does this orange belong in the red group? You can merge color stacks, blending from one color into another.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Are you wondering why you are sorting and stacking your fabric? What we have found is that it’s easier to work from an organized group of fabric than it is to work from a disorganized pile. The more you arrange and rearrange the fabric in your stack, the more color combinations you will discover.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Place your stacks next to each other. Does the background work with the appliqué fabric? Do you have the necessary light, medium, and dark values to make your quilt? Are the colors working together? Any fabric that doesn’t look good in the stack is not likely to look any better cut up and sewn into your quilt. This is the time to remove any fabric that doesn’t work. If a fabric isn’t working, force yourself to put it away.")]), _vm._v(" "), _c('p', {
    staticClass: "fpage"
  }), _vm._v(" "), _c('div', {
    staticClass: "boxb"
  }, [_c('p', {
    staticClass: "boxheadb"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _c('strong', [_vm._v("Clear Colors versus Gray Colors")])]), _vm._v(" "), _c('p', {
    staticClass: "box"
  }, [_vm._v("When you look into the distance, colors get grayer. The colors in objects close to you are sharp and clear, but with each step away, more dust and dirt and water is in the air, which reduces the clarity of the colors.")]), _vm._v(" "), _c('p', {
    staticClass: "box"
  }, [_vm._v("When you use both clear and gray colors together in a quilt, the clear colors appear to come forward. Gray or muddy colors recede. In an appliqué quilt, it is best to put the grayer colors in the background.")]), _vm._v(" "), _c('p', {
    staticClass: "box"
  }, [_vm._v("If you have a fabric that looks bad in the stack, it may be that it is either too clear or too gray to work well with the rest. Not every fabric works in every quilt.")]), _vm._v(" "), _c('p', {
    staticClass: "box"
  }, [_vm._v("Many colors live in the middle—they look gray in one stack of fabrics and clear in another. Adding some of these fabrics to your stack can add visual depth to your quilt.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f0013-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "captionb"
  }, [_vm._v("Gray colors and clear colors")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("If you have trouble knowing if the fabrics in your stack look good together, stand back and squint at them. Better yet, take a digital picture of them. Sometimes you see more in a photo than you do when you’re looking at the real thing. If you are happy with your choices, it’s time to move on. You can always add or remove fabric as you work.")]), _vm._v(" "), _c('div', {
    staticClass: "boxb"
  }, [_c('p', {
    staticClass: "boxheadb"
  }, [_c('strong', [_vm._v("Color Tip")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Sometimes you see a quilt in a book or magazine or quilt show and just "), _c('em', [_vm._v("love")]), _vm._v(" it! You want to make one just like it. You can learn a lot about how to use color, contrast, and value by using the original quilt as a guide. But eventually you’ll be ready to use color your own way. When that day comes, make a black-and-white copy of the color photo you fell in love with. This grayscale “map” of the quilt will help you place the light, medium, and dark values. Working with the black-and-white copy will also make it easier for you to see the quilt in the colors "), _c('em', [_vm._v("you")]), _vm._v(" want to use.")])]), _vm._v(" "), _c('div', {
    staticClass: "keep"
  }, [_c('h3', {
    staticClass: "h3"
  }, [_vm._v("Audition Time")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("We cut and place every fabric in position on the design wall before we take a stitch. Always. By doing this, we "), _c('em', [_vm._v("know")]), _vm._v(" that the quilt is going to be wonderful before we put all those stitches into it.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("First, put the backgrounds on the design wall. If you are going to piece your background, put all the different pieces on the wall. Sew the background blocks together only when you are sure they are balanced and work well together.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Next, starting with the first block, trace and cut out the appliqué pieces. Begin with whatever piece seems like the most obvious choice to you. Add the "), _c('img', {
    staticClass: "mid",
    attrs: {
      "alt": "image",
      "src": "html/images/frac3_16.jpg"
    }
  }), _vm._v("″ turn-under allowance and cut carefully. Use your overlay and place each piece on the wall as you go. (Refer to the information on preparing the appliqué and making and using the overlay, "), _c('span', {
    attrs: {
      "href": "#/html/9781607054726_07_ch3#page_15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("pages 15–24")]), _vm._v(".)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("On the design wall, each fabric is auditioning for its role in the quilt. Some fabrics will not make the cut. Others will be perfect. You really don’t know until you see them in place on the wall. "), _c('em', [_vm._v("You can’t fake the audition.")]), _vm._v(" Sticking some fat quarters on the wall and hoping for the best doesn’t work. Trust us; we know.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _vm._v("You will find as you read further that some appliqué shapes are easier to sew if you cut them out with excess fabric around them (see Cutaway Appliqué on "), _c('span', {
    attrs: {
      "href": "#/html/9781607054726_10_ch6#page_52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 52")]), _vm._v("). This is especially true with small, narrow, or reverse appliqué shapes. This means you won’t use every appliqué piece you have on the wall. Some pieces will be sacrificed because you will need to recut them for sewing. But your quilts will be so much better if you see every piece cut to shape (with its turn-under allowance) before you start stitching.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("We work through one block at a time, until all the appliqué pieces are on the wall, even the borders. We place sashing strips, inner borders, everything that is part of that quilt, on the wall.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Are you done? Take a giant step back and really look at your work. Begin stitching the appliqué only when you are happy with all of your fabric choices.")]), _vm._v(" "), _c('p', {
    staticClass: "fpage"
  }), _vm._v(" "), _c('div', {
    staticClass: "boxb"
  }, [_c('p', {
    staticClass: "boxheadb"
  }, [_c('strong', [_vm._v("Taking the Pieces Off the Wall")])]), _vm._v(" "), _c('p', {
    staticClass: "box"
  }, [_vm._v("After all the pieces are cut out and auditioned—and you are happy—you need to take the pieces off the wall.")]), _vm._v(" "), _c('p', {
    staticClass: "box"
  }, [_vm._v("We have designed a felt-lined storage folio to carry appliqué pieces. It is a very compact and portable way to keep your appliqué pieces flat and in order. You can also make your own simple appliqué carrier. Fold a sheet of paper in half. Cut a piece of flannel or felt 5½″ × 8½″. Open the folded paper and place the flannel or felt inside it.")]), _vm._v(" "), _c('p', {
    staticClass: "box"
  }, [_vm._v("Take your appliqué pieces off the wall starting with the highest number—the piece you will sew last. Place this piece right side up at the bottom of the felt page. Continue taking the pieces off the wall in reverse order, overlapping as necessary to create a sloped stack of appliqué pieces that ends with the #1 piece on top. Fold the paper book closed with the appliqué pieces inside. The flannel or felt keeps the fabric from shifting, and the paper adds stability. Place the folio in our Quilter’s Appliqué Caddy or in a similar project bag.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f0014-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "captionb"
  }, [_vm._v("Quilter’s Appliqué Caddy and Felt-Lined Storage Folios from C&T Publishing")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e58e3de","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/9781607054726_06_ch2.vue
// module id = 72
// module chunks = 0